import React from 'react';
import classnames from 'classnames';
import { Collapse } from 'reactstrap';
import { Icon as IconType } from 'react-feather';

interface Props {
  icon: IconType;
  title: string;
  isExpanded: boolean;
  toggle: () => void;
}

const VerticalNavMenuGroup: React.FC<Props> = ({
  icon,
  title,
  children,
  isExpanded,
  toggle,
}) => {
  const Icon = icon;

  return (
    <li
      className={classnames('nav-item has-sub', {
        open: isExpanded,
        'menu-collapsed-open': true,
        'sidebar-group-active': isExpanded,
      })}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className="d-flex align-items-center" href="#" onClick={toggle}>
        <Icon className="mb-px" />
        <span
          className="menu-item text-truncate"
          style={{ lineHeight: 'normal' }}
        >
          {title}
        </span>
      </a>
      <ul className="menu-content">
        <Collapse isOpen={isExpanded}>{children}</Collapse>
      </ul>
    </li>
  );
};

export default VerticalNavMenuGroup;
